import { ClientType, ClientTypeApi, ClientTypeInput } from "src/app/models/client.model";

export function normalizeClientType(value: ClientTypeInput | undefined): ClientType {
    if (value === ClientType.B2B || value === 2 || value === '2') return ClientType.B2B;
    if (value === ClientType.B2C || value === 1 || value === '1' || value === null || value === undefined) return ClientType.B2C;

    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'b2b' || normalized === 'company' || normalized === 'business') return ClientType.B2B;
    if (normalized === 'b2c' || normalized === 'individual' || normalized === 'consumer') return ClientType.B2C;

    return ClientType.B2C;
}

export function toApiClientType(clientType: ClientType): ClientTypeApi {
    return clientType === ClientType.B2B ? ClientTypeApi.Company : ClientTypeApi.Individual;
}